import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    editingRubricId: null,
    editingCategoryId: null,
    showCreateRubricDrawer: false,
    showCreateCategoryDrawer: false,
}

const rubricSlice = createSlice({
    name: 'rubric',
    initialState,
    reducers: {
        setEditingRubricId: (state, action) => {
            state.editingRubricId = action.payload
        },
        setEditingCategoryId: (state, action) => {
            state.editingCategoryId = action.payload
        },
        setShowCreateRubricDrawer: (state, action) => {
            state.showCreateRubricDrawer = action.payload
        },
        setShowCreateCategoryDrawer: (state, action) => {
            state.showCreateCategoryDrawer = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const rubricActions = rubricSlice.actions

export default rubricSlice.reducer
